
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3Nhdd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3a4971ea46df8d12$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $3a4971ea46df8d12$export$2e2bcd8739ae039 = {
    'identity.account-menu.account-details.manage-profile-link': "Configuraci\xf3n de la cuenta",
    'identity.account-menu.account-details.view-profile-tooltip': 'Perfil',
    'identity.account-menu.account-menu-content.log-out-button': "Cerrar sesi\xf3n",
    'identity.account-menu.account-menu-content.switch-account-button': 'Cambiar de cuenta',
    'identity.account-menu.account-menu-details.managed-account': '<b>{managedBy}</b> gestiona esta cuenta',
    'identity.account-menu.account-menu-logged-out-state.log-in': "Iniciar sesi\xf3n",
    'identity.account-menu.account-menu-popup.skeleton.tooltip': 'Cuenta',
    'identity.account-menu.theme-switcher.dark.option': 'Oscuro',
    'identity.account-menu.theme-switcher.light.option': 'Claro',
    'identity.account-menu.theme-switcher.match-browser.option': 'Igual que el navegador',
    'identity.account-menu.theme-switcher.theme-button': 'Tema'
};

});


//# sourceMappingURL=es.40a57a72.js.map
